export default __webpack_public_path__ + "static/media/diensten@2x.7783fdc0.png";